/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreatedMaintenanceRecordAdminCommand = {
  vin: string;
  sestCode: CreatedMaintenanceRecordAdminCommand.sestCode;
  replaceOdometer: number;
  replaceDate: string;
  source: CreatedMaintenanceRecordAdminCommand.source;
  isActive?: boolean;
};
export namespace CreatedMaintenanceRecordAdminCommand {
  export enum sestCode {
    _01 = '01',
    _02 = '02',
    _03 = '03',
    _04 = '04',
    _09 = '09',
    _18 = '18',
    _21 = '21',
  }
  export enum source {
    SERVICE_CENTER = 'SERVICE_CENTER',
    USER = 'USER',
    ADMIN = 'ADMIN',
  }
}

